import { EventTypes } from '../../types';
import { createGrafanaEvent } from '../base';

const { menu, collection } = EventTypes;

export const GrafanaEvents = {
    [menu.clicked]: createGrafanaEvent('menu.clicked'),
    [menu.createCollection.clicked]: createGrafanaEvent('menu.create_list_clicked'),

    [collection.create.success]: createGrafanaEvent('collection.created'),
    [collection.item.create.success]: createGrafanaEvent('collection.item.created'),
    [collection.item.create.too_many_items]: createGrafanaEvent('collection.item.too_many_items'),
    [collection.item.delete.success]: createGrafanaEvent('collection.item.deleted'),
    [collection.storage.success]: createGrafanaEvent('collection.storage.success'),
    [collection.storage.failure]: createGrafanaEvent('collection.storage.failure')
};
